import { useEffect, useState } from 'react'
import {
  CircularProgress,
  HStack,
  Image,
  StackDivider,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useWeb3React } from '@web3-react/core'
import { IOrder } from 'models/Order.model'
import { fetchUserOrders } from 'modules/order/api'

import OrderItem from './OrderItem'

export const ActiveOrders = ({ isOpen }: { isOpen: boolean }) => {
  const { account } = useWeb3React()
  const [orders, setOrders] = useState<IOrder[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setLoading(true)
      if (account) {
        fetchUserOrders(account).then((_orders) => {
          setOrders(_orders)
          setLoading(false)
        })
      } else {
        setOrders([])
        setLoading(false)
      }
    }
  }, [account, isOpen])

  if (loading) {
    return (
      <VStack alignItems="center" justifyContent="center" pt={32}>
        <CircularProgress isIndeterminate size="32px" trackColor="gray.600" />
        <Text fontWeight={'bold'} fontFamily={'mono'} color={'muted'}>
          Loading Orders
        </Text>
      </VStack>
    )
  }

  if (orders.length === 0) {
    return (
      <VStack alignItems="center" justifyContent="center" pt={32}>
        <Image
          src={'/static/icons/handshake.svg'}
          w="60px"
          h="60px"
          alt={'Handshake'}
        />
        <Text
          fontWeight={'bold'}
          fontFamily={'mono'}
          color={'muted'}
          fontSize={'lg'}
        >
          No Orders
        </Text>
      </VStack>
    )
  }
  return (
    <>
      <HStack justifyContent="space-between" alignItems="center" pb={2}>
        <Text fontFamily="mono" fontSize="xl" pt={1}>
          Active Orders
        </Text>
      </HStack>

      <VStack
        maxH={352}
        w="full"
        alignItems="stretch"
        pt={2}
        spacing={3}
        divider={<StackDivider borderColor="gray.900" />}
        overflowY="auto"
      >
        {orders.map((x, i) => (
          <OrderItem key={x._id?.toString() + i.toString()} order={x} />
        ))}
      </VStack>
    </>
  )
}

export default ActiveOrders
